
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Doctors",
      queryName: "Emergency Medicine",
      teamName: "emergency care team",
    };
  },
  components: { DoctorsList },
});
